import "../App.css";

const PostersInfo = () => {
    return (
        <div className="posters-info-banner">
            <div className="posters-info-banner__header">
                <span className="posters-info-banner__icon" aria-hidden="true">⚠</span>
                <h2 className="posters-info-banner__title">Información importante sobre los pósteres</h2>
            </div>

            <div className="posters-info-banner__content">
                <p>
                    <strong>IMPORTANTE:</strong> Los autores y coautores de los pósteres aprobados deberán
                    <br />
                    <strong> OBLIGATORIAMENTE </strong>
                    inscribirse en el siguiente enlace para poder recibir posteriormente sus certificados:&nbsp;
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLScZYnKdHfhKgjbt9lN9qTj9yDpDsrYInWHOEDdIW7fpbbniHw/viewform"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="posters-info-banner__link"
                    >
                        Clic aquí para acceder al formulario
                    </a>
                </p>
                <br />
                <p>
                    Además, deberán prestar atención a las especificaciones de los pósteres: título de la
                    investigación o actividad de investigación, autores, breve resumen, metodología, resultados
                    obtenidos o esperados y principales referencias bibliográficas.
                </p>
                <br />
                <p>
                    <strong>IMPORTANTE:</strong> Los pósteres deberán ser colocados en el campus el día
                    <strong> 28</strong>, entre las <strong>11:30 y las 12:30</strong>, y retirados el
                    <strong> martes 29</strong>, después de la premiación y cierre de actividades.
                </p>
            </div>
        </div>
    );
};

export default PostersInfo;
